// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  background-attachment: fixed;
  width: 14vw;
  padding: 20px;
  transition: width 0.3s ease;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  min-width: 14vw;
  max-width: 14vw;
  padding-right: 0;
}

.sidebar.collapsed {
  width: 80px; /* Adjust this value if needed */
}

.sidebar .icon-container {
  display: flex;
  align-items: center;
}

.sidebar .icon {
  font-size: 20px; /* Adjust icon size as needed */
}

.sidebar .sidebar-text {
  display: inline-block;
  font-size: 14px; /* Adjust text size as needed */
  margin-left: 5px; /* Adjust margin as needed */
}

.sidebar-options {
  background: transparent;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  margin-top: 5px;
  color: white;
  font-weight: bold;
}

.sidebar-options.active {
  background: #ffffff; /* Color for active (selected) sidebar option */
  color: #496c58;
  font-weight: bold;
}

/* .dabur-logo-sidebar {
  background-color: rgba(255, 255, 255, 0.334);
  border-radius: 50%;
  height: 100px;
  width: 100px;
  padding: 20px;
} */

.dabur-logo-sidebar {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.334);
  border-radius: 50%;
  height: 100px;
  width: 100px;
  padding: 20px;
}


@media (max-width: 768px) {
  .sidebar {
    width: 100%;
    height: 100%;
    min-width: none;
    max-width: none;
  }

  .sidebar .flex-column {
    width: 100%; /* Make the flex column full width on mobile */
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW,EAAE,gCAAgC;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe,EAAE,+BAA+B;AAClD;;AAEA;EACE,qBAAqB;EACrB,eAAe,EAAE,+BAA+B;EAChD,gBAAgB,EAAE,4BAA4B;AAChD;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB,EAAE,+CAA+C;EACpE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;;;GAMG;;AAEH;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;;AAGA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW,EAAE,8CAA8C;EAC7D;AACF","sourcesContent":[".sidebar {\r\n  background-attachment: fixed;\r\n  width: 14vw;\r\n  padding: 20px;\r\n  transition: width 0.3s ease;\r\n  overflow-x: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  min-width: 14vw;\r\n  max-width: 14vw;\r\n  padding-right: 0;\r\n}\r\n\r\n.sidebar.collapsed {\r\n  width: 80px; /* Adjust this value if needed */\r\n}\r\n\r\n.sidebar .icon-container {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.sidebar .icon {\r\n  font-size: 20px; /* Adjust icon size as needed */\r\n}\r\n\r\n.sidebar .sidebar-text {\r\n  display: inline-block;\r\n  font-size: 14px; /* Adjust text size as needed */\r\n  margin-left: 5px; /* Adjust margin as needed */\r\n}\r\n\r\n.sidebar-options {\r\n  background: transparent;\r\n  border-top-left-radius: 10px;\r\n  border-bottom-left-radius: 10px;\r\n  margin-top: 5px;\r\n  color: white;\r\n  font-weight: bold;\r\n}\r\n\r\n.sidebar-options.active {\r\n  background: #ffffff; /* Color for active (selected) sidebar option */\r\n  color: #496c58;\r\n  font-weight: bold;\r\n}\r\n\r\n/* .dabur-logo-sidebar {\r\n  background-color: rgba(255, 255, 255, 0.334);\r\n  border-radius: 50%;\r\n  height: 100px;\r\n  width: 100px;\r\n  padding: 20px;\r\n} */\r\n\r\n.dabur-logo-sidebar {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: rgba(255, 255, 255, 0.334);\r\n  border-radius: 50%;\r\n  height: 100px;\r\n  width: 100px;\r\n  padding: 20px;\r\n}\r\n\r\n\r\n@media (max-width: 768px) {\r\n  .sidebar {\r\n    width: 100%;\r\n    height: 100%;\r\n    min-width: none;\r\n    max-width: none;\r\n  }\r\n\r\n  .sidebar .flex-column {\r\n    width: 100%; /* Make the flex column full width on mobile */\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
